import React, { use } from 'react'
import { useState, useEffect } from 'react'
import { CiFilter } from "react-icons/ci";
import { FaFilter } from 'react-icons/fa';
import CargoModal from './modals/CardCargo';
import Footer from '../../../../components/Footer';
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { motion, AnimatePresence } from 'framer-motion';
import CargoService from '../../../../services/Cargo';
// import FilterModal from '../modal/FilterModal';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
// import { showToast } from '../../redux/slices/toastSlice';
import EmptyStateMyLoads from '../../../../Modals/empty list/EmptyList';
import DriverService from '../../../../services/Driver';
import MyLoadsContentSkeleton from './MyLoadsContentSkeleton';
import { all } from 'axios';

const DriverCargo = () => {


    const [loading,setLoading]=useState(false)


    //get all cargos
    async function getAllCargo() {
        setLoading(true);
        try {

            const param = {
                // pagination:true,
                // page:1,
                // limit:400,
                // origin:filterItems[0].selectedVal?.city,
                // destination:filterItems[1].selectedVal?.city,
                // product:filterItems[2].selectedVal,
                // car:filterItems[3].selectedVal,
                // type:filterItems[4].selectedVal
            }
            console.log(param)

            const res = await DriverService.getAllMyCargo(param)
            setAllCarogs(res?.data?.data)


        } catch (err) {

            console.log(err)
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getAllCargo()
    }, [])
    


    const [allCargos, setAllCarogs] = useState([])
    const navigate = useNavigate()

    if (loading) {
        return (
            <div className="w-full flex flex-col gap-10 lg:h-[calc(100vh-10rem)]  overflow-y-auto  py-10 lg:px-10 px-5">
                <MyLoadsContentSkeleton />
            </div>
        )
    }

    return (
        <>
            {
                allCargos?.length == 0 ?
                    <EmptyStateMyLoads

                        colorContent="text-special"
                        title="باری برای نمایش وجود ندارد"
                        subtitle="تاکنون باری ثبت نکرده اید."
                        onCta={() => { navigate("/registerCargo") }}
                        ctaText="افزودن بار جدید" >

                    </EmptyStateMyLoads>
                    :
                    <div className="w-full flex flex-col gap-10 lg:h-[calc(100vh-10rem)]  overflow-y-auto  py-10 lg:px-10 px-5">



                        <CargoModal cargos={allCargos} render={getAllCargo}></CargoModal>

                    </div>
            }

        </>
    )
}

export default DriverCargo
